module.exports = "https://static.cdns.space/tarot-temp/img/judgement.24ab285f.webp";